import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const useTelemetry = ({ race, session, driver, lap }) => {
  const { user, getIdToken } = useAuth();
  const [state, setState] = useState({ status: 'idle', data: null, error: null });

  useEffect(() => {
    if (!race || !session || !driver || !lap) {
      setState({ status: 'idle', data: null, error: null });
      return;
    }

    let cancelled = false;
    setState({ status: 'loading', data: null, error: null });

    (async () => {
      try {
        const headers = {};
        if (user) {
          const token = await getIdToken();
          if (token) headers.Authorization = `Bearer ${token}`;
        }
        const url = `${API_BASE}/api/telemetry?race=${encodeURIComponent(race)}&session=${encodeURIComponent(session)}&driver=${encodeURIComponent(driver)}&lap=${lap}`;
        const res = await fetch(url, { headers });

        if (cancelled) return;

        if (res.status === 401) {
          setState({ status: 'unauthenticated', data: null, error: null });
          return;
        }
        if (res.status === 404) {
          setState({ status: 'not_found', data: null, error: null });
          return;
        }
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const body = await res.json();
        if (!cancelled) setState({ status: 'ready', data: body, error: null });
      } catch (err) {
        if (!cancelled) {
          setState({ status: 'error', data: null, error: err.message || 'Failed to load' });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [race, session, driver, lap, user, getIdToken]);

  return state;
};
